import { useContext } from "react";
import { ThemeContext } from "../contexts/theme";

// Hook to access the theme context for components
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider.");
  }
  return context;
}
